import { useEffect } from "react";
import { useServices } from "@/services/ServiceProvider";
import { useAuthStore } from "@/stores/useAuthStore";

const HEARTBEAT_MS = 120_000;

/**
 * Stamps "last seen" while the app is visible: on mount, when the tab comes
 * back, and every 2 minutes. The RPC writes at most once a minute anyway.
 * Best effort — a failure is logged once, never surfaced.
 */
export function usePresenceHeartbeat() {
  const { organizations } = useServices();
  const viewer = useAuthStore((s) => s.session?.userId ?? null);

  useEffect(() => {
    if (!viewer) return;
    let warned = false;
    const touch = () => {
      if (document.visibilityState !== "visible") return;
      organizations.touchPresence().catch((err: unknown) => {
        if (!warned) console.warn("[presence] heartbeat failed", err);
        warned = true;
      });
    };
    touch();
    const timer = window.setInterval(touch, HEARTBEAT_MS);
    document.addEventListener("visibilitychange", touch);
    return () => {
      window.clearInterval(timer);
      document.removeEventListener("visibilitychange", touch);
    };
  }, [organizations, viewer]);
}
